export enum FieldStatusTypes {
  active = 'bg-success',
  inactive = 'bg-neutral',
  warn = 'bg-warning',
  danger = 'bg-danger'
}

export type FieldStatusType = 'active' | 'inactive' | 'warn' | 'danger'
